"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
const Tab_1 = __importDefault(require("@material-ui/core/Tab"));
const styles_1 = require("@material-ui/core/styles");
const silica_1 = require("@opendoor/silica");
const useTabsStyles = styles_1.makeStyles(() => styles_1.createStyles({
    indicator: {
        backgroundColor: silica_1.colors.gray6,
    },
}));
const useTabStyles = styles_1.makeStyles(() => styles_1.createStyles({
    textColorInherit: {
        '&.Mui-selected': {
            color: silica_1.colors.gray6,
        },
    },
}));
const SecondaryNavigationBar = ({ links, renderPanel, isPanelConstrained = true, hasShadow, }) => {
    const tabsStyles = useTabsStyles();
    const tabStyles = useTabStyles();
    if (!(links === null || links === void 0 ? void 0 : links.length) && !renderPanel) {
        return react_1.default.createElement("div", null);
    }
    let selectedIndex = links ? links.findIndex((link) => link.isActive) : -1;
    return (react_1.default.createElement("div", { className: 'flex-none flex items-end pl-6 h-5 ' + (hasShadow ? 'shadow-1' : 'bo-gray2 bob-2') },
        links && links.length ? (react_1.default.createElement(Tabs_1.default, { classes: tabsStyles, className: "ml-5 h-100%", value: selectedIndex >= 0 ? selectedIndex : false }, links.map(({ href, onClick, title, component, componentProps }, index) => (react_1.default.createElement(Tab_1.default, Object.assign({ classes: tabStyles, key: index, value: index, href: href || '#', onClick: onClick, label: title, component: component }, componentProps)))))) : (react_1.default.createElement("div", null)),
        react_1.default.createElement("div", { className: 'ml-auto h-100% ' +
                (isPanelConstrained
                    ? 'bot-4 bo-transparent pv-5 pr-6'
                    : 'flex-grow-1 flex self-center items-center overflow-x-hidden') }, renderPanel && renderPanel())));
};
exports.default = SecondaryNavigationBar;
